// Browser-safe replacement for asn1.js's optional Node vm optimization.
// asn1.js catches this error and uses its normal closure-based constructor.
export const runInThisContext = (): never => {
  throw new Error("Node vm is unavailable in the browser");
};

export default { runInThisContext };
